import React from "react";
import { Link } from "react-router-dom";
import { Map, Plus } from "lucide-react";
import { Button } from "../../components/ui/button";

/**
 * FeedActionButtons — the Explore Map + Create Video CTA pair that
 * sits below the founding-badge on the landing. When logged-out, the
 * Create Video button fires the global `open-auth` event with
 * register=true so users land on the signup modal instead of being
 * bounced back to / by ProtectedRoute.
 *
 * Props:
 *   user — current viewer (null when logged out)
 */
export const FeedActionButtons = ({ user }) => (
  <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
    <Link to="/map">
      <Button
        size="lg"
        variant="outline"
        className="border-emerald-500/50 text-emerald-400 hover:bg-emerald-500/10 w-full sm:w-auto"
        data-testid="landing-explore-map-btn"
      >
        <Map className="h-5 w-5 mr-2" /> Explore Map
      </Button>
    </Link>
    {user ? (
      <Link to="/dashboard">
        <Button
          size="lg"
          variant="outline"
          className="border-gray-600 text-gray-300 hover:bg-gray-800 w-full sm:w-auto"
          data-testid="landing-create-video-btn"
        >
          <Plus className="h-5 w-5 mr-2" /> Create Video
        </Button>
      </Link>
    ) : (
      <Button
        size="lg"
        variant="outline"
        className="border-gray-600 text-gray-300 hover:bg-gray-800 w-full sm:w-auto"
        onClick={() => window.dispatchEvent(new CustomEvent("open-auth", { detail: { register: true } }))}
        data-testid="landing-create-video-btn"
      >
        <Plus className="h-5 w-5 mr-2" /> Create Video
      </Button>
    )}
  </div>
);
